module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAjCAYAAADBl8lGAAAACXBIWXMAABcRAAAXEQHKJvM/AAABRUlEQVRYw+2ZMQ6DMAxFY4uZQ3C3DkU9DmLhbOUQ7MWdKiFEgx3H4CCYWIC8/G9/pwUiCqnXPLYUQgjY9BCcXqiFW99fBjAGXDygZ8XMFLwMYEw9j8reCpZen1jy4m+LSgAl6nlS+vIKVlYvnseWNDPq9HixXFAPXfQbwBm2Uy2XAsgF44Ji6sItThCpcLFn0bJhSJ7VwMXegUfYLgdcPXSwV2/ZuygHNkdkLMGkkChZ3BkndynQ2g3qHDxKxexBX+LcqQr6M+2p6bCbQW+lHneTtJGxrNvKk51yZOGpw3bMGRZwm4Dem4s0NqpcdaPZHO4ko1ZQq55VJqbC7dagh/8cNHAmTcbbZIPem8u6PqXdFohoE05rT+6GYdODRUT8rI3/FnLUQXceW9LWWUx5N7+qWUHC5/0kiw4qsag0F7lDeD108AWX6toPfNLVywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/09.png
// module id = ApMs
// module chunks = 2